import { useState } from 'react'

import { useDashboardStorage } from '../../../../../../../../hooks/useDashboardStorage'

const KEYS = [
  'newPost',
  'welcomePost',
  'discord',
  'products',
  'promotions',
  'twitchDiscount',
  'spotify',
] as const

type Key = (typeof KEYS)[number]

type Visibility = Record<Key, boolean>

type SuggestionsDismiss = {
  [K in Key]: {
    visible: boolean
    dismiss: () => void
  }
}

export const useSuggestionsDismiss = () => {
  const { dashboardStorage } = useDashboardStorage()
  const initialVisibility = KEYS.reduce<Visibility>(
    (acc, key) => ({
      ...acc,
      [key]: !dashboardStorage.get(`membershipsSuggestionsDismiss.${key}`),
    }),
    {} as Visibility,
  )
  const [visibility, setVisibility] = useState<Visibility>(initialVisibility)

  const dismiss = (key: Key) => {
    setVisibility((prev) => ({ ...prev, [key]: false }))
    dashboardStorage.set(`membershipsSuggestionsDismiss.${key}`, true)
  }

  const suggestionsDismiss = KEYS.reduce<SuggestionsDismiss>(
    (acc, key) => ({
      ...acc,
      [key]: { visible: visibility[key], dismiss: () => dismiss(key) },
    }),
    {} as SuggestionsDismiss,
  )

  return { suggestionsDismiss }
}
